import axios from 'axios'
import store from '@/store'

import router from '@/router'
import { Message } from 'element-ui'
import qs from 'qs';

// 诊断：记录触发 redirectLogin 的请求，便于在企微 H5 上定位「闪屏死循环」根因
// 保存最近 5 条记录，保留完整链路（哪条请求 401/406 → 哪个 redirectLogin）
function recordAuthFail (info) {
  try {
    const list = JSON.parse(sessionStorage.getItem('wxoauth_diag') || '[]')
    list.push(Object.assign({ t: Date.now() }, info))
    if (list.length > 5) list.shift()
    sessionStorage.setItem('wxoauth_diag', JSON.stringify(list))
  } catch (e) { /* sessionStorage 不可用时静默忽略 */ }
}

// 跳转登录页面重新授权（只 router.push，不整页 reload，避免企微 H5 闪屏死循环）
// 企微登录返回的 token 只有 access_token、没有 refresh_token，
// 因此 token 失效（过期/被拉黑/签名无效）时无法刷新，只能清 token 后重新授权
function goLogin (reason) {
  // 无论是否已在登录页，先清掉失效 token，保证 hasValidToken 判定为 false 走重新授权
  try { window.localStorage.removeItem('token') } catch (e) { /* 忽略 */ }
  store.state.user.token = null
  recordAuthFail({ phase: 'goLogin', route: router.currentRoute.fullPath, reason })
  // 已在登录页：不重复跳转（login 页会自行判断重新授权）
  if (router.currentRoute.name === 'login') return
  router.push({
    name: 'login',
    query: {
      redirect: router.currentRoute.fullPath
    }
  }).catch(() => { /* 重复导航忽略 */ })
}

// 请求超时时间
//axios.defaults.timeout = 10000 * 5

// 请求基础 URL（由 .env.* 文件统一管理）
axios.defaults.baseURL = process.env.VUE_APP_BASE_API

// POST 请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

// 请求拦截器
axios.interceptors.request.use(
  config => {
    const { token } = store.state.user
    if (token && token.access_token) {
      // 用赋值属性而非替换整个 headers 对象，避免丢失 Content-Type 等默认头
      config.headers.Authorization = token.token_type + ' ' + token.access_token
    } else {
      // 诊断：记录某请求发出时 store 里没有可用 token
      var _t = store.state.user.token
      recordAuthFail({ phase: 'request-no-token', url: config.url, hasToken: !!_t, tokenType: typeof _t, hasAccess: !!(_t && _t.access_token) })
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)


// 响应拦截器
let isredirecting = false
let requests = []
axios.interceptors.response.use(
  response => {
    //如果是下载文件，把文件名返回
    /*if (response.headers['file-name']) {
      return {
        fileName: decodeURI(response.headers['file-name']), data: response.data
      }
    }*/
    if (response.headers && response.headers['content-disposition']) {
      const cd = response.headers['content-disposition']
      const cds = cd.split("utf-8''")
      if (cds.length > 1) {
        const fileName = decodeURIComponent(cds[1])
        return { fileName, data: response.data }
      } else {
        return { fileName: cd.split('=')[1].split(';')[0], data: response.data }
      }
    }
    // 统一处理后台返回的 code：成功不再全局弹提示，由业务代码自行控制；失败仍统一拦截提示
    const { data } = response
    if (data.code === 0 || data.code === 200) {
      // 成功提示统一交给业务代码控制（如 this.$message.success(...)），避免双层提示
    } else {
      if (data.code === 406) {
        const detail = data.detail || data.error || data.msg || data.message
        recordAuthFail({ phase: 'response-406', url: response.config && response.config.url, code: data.code, error: data.error || data.msg || data.message, detail })
        // 406 业务码只有 JWT 鉴权异常在用（过期/拉黑/无效/为空），代表当前 token 已失效。
        // 企微 token 无 refresh_token 无法刷新 → 一律清 token + 跳登录页重新授权
        // （只跳转不 reload，避免死循环）
        goLogin('response-406-invalid-token')
        return Promise.reject({ code: 406, message: detail, data })
      }
      const msg = data.message || data.msg
      if (msg && data.code !== -2) Message.error({ message: msg, offset: 60 })
    }
    return data
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 404:
          Message.warning('接口不存在，请刷新重试或联系管理员')
          return Promise.reject(error)
        case 401:
          recordAuthFail({
            phase: 'error-401',
            url: error.config && error.config.url,
            status: error.response && error.response.status,
            hasToken: !!store.state.user.token,
            hasRefresh: !!(store.state.user.token && store.state.user.token.refresh_token)
          })
          // 无 token，或 token 没有 refresh_token（企微/钉钉登录都只有 access_token，无法刷新）
          // → 清 token + 跳登录页重新授权（不 reload，避免死循环）
          if (!store.state.user.token || !store.state.user.token.refresh_token) {
            goLogin('error-401-no-refresh')
            return Promise.reject(error)
          }
          // 有 refresh_token：走原有刷新逻辑
          if (isredirecting) {
            return requests.push(() => {
              axios(error.config)
            })
          }
          isredirecting = true
          return axios({
            method: 'POST',
            url: '/auth/refresh',
            params: { refresh_token: store.state.user.token.refresh_token }
          }).then(resolve => {
            if (resolve.code !== 0) {
              // 刷新token失败
              store.commit('setUserInfo', null)
              goLogin('refresh-token-fail')
            }
            // 下面是刷新token成功
            store.commit('setToken', JSON.stringify(resolve.data))
            // 重新发送 刷新token之前的 请求
            requests.forEach(callback => callback())
            requests = []
            return axios(error.config)
          }).catch(reject => {
            return Promise.reject(reject)
          }).finally(() => {
            isredirecting = false
          })
        case 500:
          Message.error('服务异常，请稍后刷新重试或联系管理员')
          return Promise.reject(error)
        case 502:
          Message.error('服务异常，请稍后刷新重试或联系管理员')
          return Promise.reject(error)
        default:
          Message.warning(error.response.data.message)
          return Promise.reject(error.response)
      }
    }
  })
/**
 * 封装 get方法 对应 GET 请求
 * @param {string} url 请求url
 * @param {object} params 查询参数
 * @returns {Promise}
 */
export function get (url, data) {
  if (data) {
    data.hash = window.location.hash.replace('#', '')
    url = url + `?${qs.stringify(data)}`
  }
  return axios.get(url)
}
/**
 * 封装 post 方法，对应 POST 请求
 * @param {string} url 请求url
 * @param {object} data 请求体
 * @param {boolean | undefined} info 请求体是否为 FormData 格式
 * @returns {Promise}
 */
export function post (url, data = {}, info) {
  data.hash = window.location.hash.replace('#', '')
  let newData = data
  // 默认使用 FormData 格式，支持数组参数
  if (info !== false) {
    newData = new FormData()
    for (const i in data) {
      const val = data[i]
      if (Array.isArray(val)) {
        // 数组参数：JSON 序列化每个元素（避免对象被 toString 成 "[object Object]"）
        val.forEach(v => newData.append(i + '[]', typeof v === 'object' ? JSON.stringify(v) : v))
      } else if (typeof val === 'object' && val !== null) {
        // 对象参数：JSON 序列化
        newData.append(i, JSON.stringify(val))
      } else {
        newData.append(i, val)
      }
    }
  }
  return axios.post(url, newData)
}
/**
 * 封装 post 方法（JSON 请求体，Content-Type: application/json）
 * 用途：payload 是「大对象数组」时必须用这个。urlencoded 会被 PHP max_input_vars
 * （线上默认 1000，超出部分静默丢弃、不报错）截断数组末尾的元素，
 * 表现为「没删行却提示某行被删除」。JSON 请求体由 Laravel 整体 json_decode，不受该限制。
 * @param {string} url 请求url
 * @param {object} data 请求体
 * @returns {Promise}
 */
export function postJson (url, data = {}) {
  data.hash = window.location.hash.replace('#', '')
  return axios.post(url, data, { headers: { 'Content-Type': 'application/json' } })
}
/**
 * 封装带进度条的 post 请求
 * @param {string} url 请求url
 * @param {object} data 请求体
 * @param {funcction} onDownloadProgress 进度回调
 * @param {object} cancelToken 标记正在请求的资源
 * @param {boolean | undefined} info 请求体是否为 FormData 格式
 * @returns {Promise}
 */
export function postProgress (url, data = {}, onDownloadProgress, cancelToken, info,) {
  data.hash = window.location.hash.replace('#', '')
  let newData = data
  if (info) {
    newData = new FormData()
    for (const i in data) newData.append(i, data[i])
  }
  return axios({
    url,
    method: 'POST',
    responseType: "blob",
    data: newData,
    onDownloadProgress,
    cancelToken
  })
}
